import styled from '@emotion/styled';

export const ClientBox = styled.div`
  width: 166px;
  min-height: 44px;
  flex-basis: 166px;
  padding: 8px 12px;

  background-color: ${({ theme }) => theme.colors.skyblue_100};
  border-radius: 4px;
  white-space: pre-wrap;

  word-break: break-all;
`;

export const Button = styled.button`
  height: 17px;
`;
